export default __webpack_public_path__ + "static/OfficialMap-80e9751e014100d1909495ca9756e724.jpg";